<template>
  <div class="h-full flex flex-col">
    <Title title="Favourites" />
    <div v-if="favourites.length > 0" class="flex-1 overflow-scroll p-4">
      <FavouriteItem
        v-for="(item, index) in favourites"
        @removeItem="removeFavourite"
        :key="item"
        :itemID="item"
        :index="index"
      />
      <div class="h-14"></div>
    </div>
    <div v-else class="flex-1 flex flex-col justify-center items-center">
      <p class="mx-auto mb-4 font-medium text-xl">No Favourites Yet!</p>
      <div>
        <button
          @click="browseMenu"
          class="shadow-lg border-white border font-bold text-lg p-1 px-4 rounded-full bg-bnb-mustard bg-opacity-70 text-white"
        >
          Browse Menu
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Title from "@/components/Title.vue";
import FavouriteItem from "@/views/more/favourites/FavouriteItem.vue";
export default {
  components: { Title, FavouriteItem },
  created() {
    try {
      this.favourites = JSON.parse(localStorage.favourites).reverse();
    } catch (error) {
      localStorage.removeItem("favourites");
      console.error(error);
    }
  },
  data() {
    return {
      favourites: [],
    };
  },
  methods: {
    removeFavourite(id) {
      if (id) {
        try {
          var favourites = JSON.parse(localStorage.favourites).filter(
            (e) => e != id
          );
          localStorage.favourites = JSON.stringify(favourites);
          this.favourites = favourites;
        } catch (error) {
          console.error("Error removing favourite: ", error);
        }
      }
    },
    browseMenu() {
      this.$store.commit("currentComponent", "Menu");
      this.$router.go(-1);
    },
  },
};
</script>
